import { DEFAULT_PREFIX, provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonTypography } from './Typography.definition';
export function registerCustom({ prefix = DEFAULT_PREFIX, node } = {}) {
    provideChameleonDesignSystem({ prefix, node }).register(chameleonTypography({ prefix }));
}
